function localizeClientState(state, t) {
  if (!state) return state;
  const states = t.admin || {};
  const labels = {
    affiliated: states.affiliated,
    contacted: states.contacted,
    visited: states.visited,
    completed: states.completed,
    welcome_bonus: states.welcomeBonus,
  };
  return labels[state] || state;
}

function localizeProspectStatus(status, t) {
  if (!status) return status;
  const key = String(status).trim().toUpperCase();
  return t?.vendor?.prospects?.statuses?.[key] || status;
}

function resolveNotificationParams(rawParams, t) {
  const f = t.notifications?.fallbacks || {};
  const params = { ...(rawParams || {}) };

  ['state', 'fromState', 'toState'].forEach((key) => {
    if (params[key]) {
      params[key] = localizeClientState(params[key], t);
    }
  });

  if (params.status) {
    params.status = localizeProspectStatus(params.status, t);
  }

  if (params.tier) {
    params.tier = t.enrola?.chests?.[params.tier] || params.tier;
  }

  return {
    vendorName: params.vendorName ?? f.unknownVendor,
    clientName: params.clientName ?? f.unknownClient,
    prospectName: params.prospectName ?? f.unknownProspect,
    referrer: params.referrer ?? f.unknownMember,
    newClient: params.newClient ?? f.unknownClient,
    username: params.username ?? f.unknownClient,
    rewardName: params.rewardName ?? f.unknownReward,
    videoTitle: params.videoTitle ?? f.unknownVideo,
    points: params.points ?? 0,
    count: params.count ?? 0,
    ...params,
  };
}

export function translateNotification(notification, t, formatMessage) {
  const messageKey = notification.message_key;
  if (!messageKey) {
    return {
      title: notification.title,
      message: notification.message,
    };
  }

  const entry = t.notifications?.messages?.[messageKey];
  if (!entry) {
    return {
      title: notification.title || messageKey,
      message: notification.message || '',
    };
  }

  const params = resolveNotificationParams(notification.message_params, t);
  return {
    title: formatMessage(entry.title, params),
    message: formatMessage(entry.message, params),
  };
}
